import currency from 'currency.js';
import { COUNTRY } from '@/config';


export const currencies = {
  mx: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: 'MX$ ',
    formatWithSymbol: true,
  }),
  cl: value => currency(value, {
    separator: '.',
    precision: 0,
    symbol: 'CLP$ ',
    formatWithSymbol: true,
  }),
  co: value => currency(value, {
    separator: '.',
    precision: 0,
    symbol: 'COP$ ',
    formatWithSymbol: true,
  }),
  br: value => currency(value, {
    separator: '.',
    decimal: ',',
    symbol: 'R$ ',
    formatWithSymbol: true,
  }),
  ar: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: 'AR$ ',
    formatWithSymbol: true,
  }),
  bo: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: 'Bs ',
    formatWithSymbol: true,
  }),
  cr: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: '₡',
    formatWithSymbol: true,
  }),
  ec: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: 'US$ ',
    formatWithSymbol: true,
  }),
  do: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: 'RD$',
    formatWithSymbol: true,
  }),
  gt: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: 'Q',
    formatWithSymbol: true,
  }),
  pa: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: 'B/.',
    formatWithSymbol: true,
  }),
  pe: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: 'S/',
    formatWithSymbol: true,
  }),
  py: value => currency(value, {
    separator: ',',
    decimal: ',',
    symbol: 'Gs',
    formatWithSymbol: true,
  }),
  sv: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: '$',
    formatWithSymbol: true,
  }),
  uy: value => currency(value, {
    separator: ',',
    decimal: '.',
    symbol: 'UYU$',
    formatWithSymbol: true,
  }),
};

export const currentCurrency = currencies[COUNTRY] ? currencies[COUNTRY] : currencies.br;
